import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/Login/Login";
import RegistrationSuccess from "../pages/Registration/RegistrationSuccess";
import ForgotPassword from "../pages/Login/ForgotPassword";
import BasicTabs from "../pages/Home/Home";
import GenerateInvoice from "../pages/PatientManagement/InvoiceManagement/GenerateInvoice";
import Registration from "../pages/Registration/Registration";
import ResetPassword from "../pages/Login/RestPassword";
import ConsultationInvoice from "../pages/PatientManagement/InvoiceManagement/ConsultationInvoice";
import InvoicePreviewPage from "../pages/PatientManagement/InvoiceManagement/InvoicePreviewPage";
import ClinicMateLanding from "../pages/Landing/ClinicMateLanding";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<ClinicMateLanding />} />
    <Route path="/login" element={<Login />} />
    <Route path="/registration" element={<Registration />} />
    <Route path="/registration_success" element={<RegistrationSuccess />} />
    <Route path="/consultation-invoice" element={<ConsultationInvoice />} />
    <Route path="/invoice/preview" element={<InvoicePreviewPage />} />
    <Route path="/forgotPassword" element={<ForgotPassword />} />
    <Route path="/reset-password" element={<ResetPassword />} />

    {/* ALL SECURED ROUTES */}
    <Route path="/*" element={<BasicTabs />} />

    <Route path="/home" element={<Navigate to="/dashboard" replace />} />

  </Routes>
);

export default AppRoutes;
